let SERVER_CONFIG = {}
if (process.env.NODE_ENV === 'development') {
  SERVER_CONFIG = {
    // SERVER: 'http://localhost:8079',
    SERVER: 'http://42.193.250.73:8079',
    PATH: '/'
  }
} else {
  SERVER_CONFIG = {
    //兰州交通大学
    // SERVER: 'http://192.168.8.41:8079',
    //山东聊城大学
    // SERVER: 'http://192.168.8.4:8079',
    SERVER: 'http://42.193.250.73:8079',
    PATH: '/'
  }
}
export default SERVER_CONFIG
